import React from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "../ConfirmDeactivateModal.css";

const StockUpdateModal = ({ show, onClose, onConfirm, reason, setReason, quantity, setQuantity   }) => {
  const { t } = useTranslation();
  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      dialogClassName="custom-modal"
    >
      <Modal.Body>
        <div className="text-center">
           <div className="warning-icon mb-3">
          <img
            src="https://cdn-icons-png.flaticon.com/512/15554/15554971.png"
            alt="update"
            width={40}
          />
        </div>
          <p className="cancel-message fw-semibold mt-3">
            {t("admin.stockUpdate.title")} <br />
          <strong><em><span className="fw-light mt-1 text-left" style={{fontSize: "12px"}}>{t("admin.stockUpdate.instruction")}</span></em></strong>
          </p>

          <Form.Control
            type="number"
            placeholder={t("common.quantity")}
            value={quantity}
            onChange={(e) => setQuantity(e?.target?.value)}
            className="cancel-reason-input"
            required
          />
          {(!quantity || quantity == 0 )&& <span className="error-text mb-3 ml-auto float-left">{t("admin.stockUpdate.quantityRequired")}</span>}

          <Form.Control
            as="textarea"
            rows={3}
            placeholder={t("common.notes")}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            className="cancel-reason-input"
            required
          />
          {!reason?.trim() && <span className="error-text ml-auto float-left">{t("admin.stockUpdate.notesRequired")}</span>}

 <div className="d-flex justify-content-end gap-3 mt-4">
          <Button variant="light" onClick={onClose} className="btn-no mr-4">
            {t("common.cancel")}
          </Button>
          <Button  onClick={onConfirm}
              disabled={!reason?.trim() || !quantity || quantity == 0} variant="primary"  className="btn-yes">
            {t("common.submit")}
          </Button>
        </div>
        
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default StockUpdateModal;
